let BACKEND_SERVER = null;
if (process.env.REACT_APP_BACKEND_SERVER) {
  BACKEND_SERVER = process.env.REACT_APP_BACKEND_SERVER;
} else {  
      //  BACKEND_SERVER = "http://35.183.46.127:5555"; //old server ip
    //  BACKEND_SERVER = "http://15.156.37.6:5555"; //new  server ip/
      // BACKEND_SERVER = "http://192.168.1.67:5556"; 
      //  BACKEND_SERVER = "http://192.168.1.67:5558"; 
      //  BACKEND_SERVER = "https://api.atlantis.com:5555"; 
  //  BACKEND_SERVER = "http://localhost:5558";
  BACKEND_SERVER = "https://test.atlantisworld.co:5555";
  //  BACKEND_SERVER = "https://atlantisworld.co:5555";
  // BACKEND_SERVER = "http://192.168.1.71:5558"; 
  //  BACKEND_SERVE R = "https://api.atlantis.com:5555";
  // BACKEND_SERVER = "http://192.168.1.16:5559";
  // BACKEND_SERVER = "http://192.168.1.5:5557"; 
      }
// export const GPT_API_KEY = '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' ;
export const API_SERVER = BACKEND_SERVER;
export const Notelength = 150; 
export const Dialoglength = 300;
export const Responselength = 300;
export const DemoPlayRoutePath = '/game/creator/demoplay/';
export const previewPlayRoutePath = '/game/creator/preview/';
export const ReviewPlayRoutePath = '/game/creator/Review/';
    